<template>
	<div v-if="message" :class="classList">
		<i class="ri-information-line"></i>
		{{ message }}
	</div>
</template>

<script>
export default {
	props: {
		message: {
			type: String,
			default: '',
		},
		large: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		classList() {
			return ['form-input-hint', { 'form-input-hint--large': this.large }];
		},
	},
};
</script>

<style>
.form-input-hint {
	margin-top: 0.375rem;
	padding-left: 1.25em;
	color: #666;
	font-size: 0.8125rem;
	font-weight: 300;
	letter-spacing: -0.05em;
	word-break: keep-all;
}

.form-input-hint--large {
	font-size: 0.9375rem;
}

.form-input-hint i {
	float: left;
	margin-left: -1.25em;
	vertical-align: middle;
}

.form-input-hint::after {
	content: '';
	display: table;
	clear: both;
}

.has-error .form-input-hint,
.is-error + .form-input-hint {
	color: #f53838;
}

.has-success .form-input-hint,
.is-success + .form-input-hint {
	color: #32b643;
}
</style>
